import { CodeMirrorType } from '../../models/CodeMirrorType';

function getCodeMirrorInstance(codeMirrorInstance: CodeMirrorType) {
    if (codeMirrorInstance && codeMirrorInstance.editor) {
        codeMirrorInstance = codeMirrorInstance.editor;
        return codeMirrorInstance;
    }
    return null;
}

export default getCodeMirrorInstance;
